import { get, post } from "../axiosConfig";
import {
  BillingOverview,
  ExpensesOverview,
  Expense,
  Replenishment,
} from "../../../types";

export const BillingAPI = {
  async topup(payload: {
    amount: number;
    type: "PAYCRYPTO" | "YOOKASSA";
  }): Promise<{ url: string }> {
    const { data } = await post("/billing/replenishments", payload);
    return data;
  },

  async getBillingOverview(): Promise<BillingOverview> {
    const { data } = await get("/billing/overview");
    return data;
  },

  async getExpensesOverview(): Promise<ExpensesOverview> {
    const { data } = await get("/billing/expenses/overview");
    return data;
  },

  async getExpensesList(): Promise<Expense[]> {
    const { data } = await get("/billing/expenses");
    return data;
  },

  async getReplenishmentsList({
    search,
    limit,
  }: {
    search: string | null;
    limit?: number;
  }): Promise<{ count: number; items: Replenishment[] }> {
    const params: { search?: string; limit?: number } = {};
    if (!!search) {
      params.search = search;
    }
    if (!!limit) {
      params.limit = limit;
    }
    const { data } = await get("/billing/replenishments", {
      params,
    });
    return data;
  },
};
